import ApiEndpoints from '../ApiEndpoints';
import { Dispatch } from 'redux';
import ActionType from '../actionTypes/kapinuaColorsActionTypes';
import { handleRequest } from './helpers';
import KapinuaColorsConverter from '../../converter/KapinuaColorsConverter';

const loadKapinuaColors =
    () =>
    async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
        const url = ApiEndpoints.KAPINUA_COLORS_LOAD();
        const actionTypes = ActionType.loadColors;

        return handleRequest(
            url,
            dispatch,
            actionTypes,
            (colorsRaw: any) => {
                return KapinuaColorsConverter.convertAll(colorsRaw);
            },
            'get'
        );
    };

export { loadKapinuaColors };
